module.exports = __webpack_public_path__ + "assets/img/new-scan-icon-dropzone.7bfd7901.svg";